import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContentHandlerService {
  constructor(private http: HttpClient) {}

  uploadBase64(base64Content: string): Observable<string> {
    const body = {
      file_contents: base64Content,
    };

    return this.http.post('files', body).pipe(map((response) => response['file_contents']));
  }

  uploadFile(file: File): Observable<string> {
    const formData = new FormData();

    formData.append('file_contents', file);

    return this.http.post('files', formData).pipe(map((response) => response['file_contents']));
  }
}
